<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="套餐系列：">
                <el-select v-model="searchForm.typeGroupId" filterable clearable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐类型：">
                <el-select v-model="searchForm.type" clearable>
                    <el-option v-for="item in pkgTypeOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属类别：">
                <el-select v-model="searchForm.supplierType" clearable>
                    <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option v-for="item in pkgStateOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐名称：">
                <el-input v-model.trim="searchForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgListPageHandle" plain icon="el-icon-search">查询</el-button>
                <el-button type="primary" plain icon="el-icon-plus" @click="showAddPkg">新增套餐</el-button>
                <!-- <el-button type="primary" @click="updateUpPkg">同步上游套餐</el-button> -->
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"  >           
            <el-table-column prop="id" label="套餐编码" align="center"  width="180"></el-table-column>
            <el-table-column prop="typeGroupName" label="套餐系列"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="套餐名称"  align="center" show-overflow-tooltip  width="180"></el-table-column>
            <el-table-column prop="typeName" label="套餐类型"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="totalData" label="套餐流量(G)" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="salePriceRmb" label="套餐金额" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="verifyPriceRmb" label="套餐对账价格" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="voices" label="套餐语音(分钟)" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="otherPkgId" label="上游套餐编码"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="排序" align="center"  show-overflow-tooltip>
                <template v-slot="scope" >
                    <el-input v-model="scope.row.sort" maxlength="8" size="mini" @change="updateSortNo(scope.row)" clearable></el-input>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="supplierTypeName" align="center" label="所属类别" ></el-table-column> -->
            <el-table-column prop="stateName" align="center" label="状态" ></el-table-column>
            <el-table-column prop="createTime" align="center" label="添加时间" width="140"></el-table-column>
            <el-table-column label="操作" width="120" align="center" fixed="right">
                <template v-slot="scope">
                    <el-button type="text" size="small" @click="showEditPkg(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="changePkgStateHandle(scope.row.id)">
						<span style="color: red;">
							{{ showbtnText(scope.row.state) }}
						</span>
					</el-button>
                </template>             
            </el-table-column>
        </el-table>  
                 
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>    
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addPkgVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditPkgForm" :model="addOrEditPkgForm" :rules="addOrEditPkgRules" label-width="120px">
                <el-form-item label="套餐组名称：" prop="typeGroupId">
                    <el-col :span="22">
                        <el-select v-model="addOrEditPkgForm.typeGroupId" filterable @change="whenChoosePagGroup">
                            <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name" ></el-option>
                        </el-select>                        
                    </el-col>
                </el-form-item>
                
                <el-form-item label="套餐名称：" prop="name">
                    <el-col :span="22">
                        <el-input v-model.trim="addOrEditPkgForm.name" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                <el-form-item label="套餐对账价格：" prop="verifyPriceRmb">                    
                    <el-col :span="22">
                        <el-input type=number v-model="addOrEditPkgForm.verifyPriceRmb"></el-input>                        
                    </el-col>
                    <el-col :span="2" class="center">元</el-col> 
                </el-form-item>
                
                <el-form-item label="套餐售价：" prop="salePriceRmb">
                    <el-col :span="22">
                        <el-input type=number v-model="addOrEditPkgForm.salePriceRmb"></el-input>
                    </el-col>
                    <el-col :span="2" class="center">元</el-col>                    
                </el-form-item>
                <el-form-item label="流量：" prop="flowRate">
                    <el-col :span="22">
                        <el-input type=number v-model="addOrEditPkgForm.flowRate" class="input-with-select" >
                            <el-select v-model="unit" slot="append">
                                <el-option value="G" label="G"></el-option>
                                <el-option value="M" label="M"></el-option>
                            </el-select>
                        </el-input>
                    </el-col>                  
                </el-form-item>
                <el-form-item label="可使用流量：" prop="flowRatePercent">
                    <el-col :span="22">
                        <el-input v-model="addOrEditPkgForm.flowRatePercent"  placeholder="请输入1~99.99"></el-input>
                    </el-col> 
                    <el-col :span="2" class="center">%</el-col>
                </el-form-item>
                <!-- v-if="addOrEditPkgForm.supplierType != 66" 之前加了这个判断-->
                <el-form-item label="套餐类型：" prop="type">
                    <el-col :span="22">
                        <el-select v-model="addOrEditPkgForm.type" clearable>
                            <el-option v-for="item in pkgTypeOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                        </el-select>
                        
                    </el-col>
                </el-form-item> 

                <!--  when  addOrEditPkgForm.supplierType = 66 -->
                <el-form-item label="套餐编码："  v-if="addOrEditPkgForm.supplierType == 66">
                    <el-col :span="22">
                        <!-- <el-select v-model="addOrEditPkgForm.otherPkgId" filterable>
                            <el-option v-for="item in myPkgGroup" :key="item.id" :value="item.id" :label="item.name+' - '+item.id"></el-option>
                        </el-select>                         -->
                        <el-input v-model="addOrEditPkgForm.otherPkgId"  placeholder=""></el-input>
                    </el-col>
                </el-form-item>
                <!-- //  when  addOrEditPkgForm.supplierType = 66 -->

                <el-form-item label="套餐编码："  v-if="addOrEditPkgForm.supplierType != 66" >
                    <el-col :span="22">
                        <!-- <el-input v-model.trim="addOrEditPkgForm.otherPkgId"></el-input> -->
                        <el-input v-model="addOrEditPkgForm.otherPkgId"  placeholder="上游得套餐编码"></el-input>
                    </el-col>
                </el-form-item> 
                  <el-form-item label="套餐备注：" >
                    <el-col :span="22">
                        <!-- <el-input v-model.trim="addOrEditPkgForm.otherPkgId"></el-input> -->
                        <el-input v-model="addOrEditPkgForm.remark"  placeholder="在微信端和APP端展示给用户套餐备注"></el-input>
                    </el-col>
                </el-form-item> 

                 <el-form-item label="语音时长：" v-show="showVoice" >
                    <el-col :span="22">
                        <!-- <el-input v-model.trim="addOrEditPkgForm.otherPkgId"></el-input> -->
                        <el-input v-model="addOrEditPkgForm.voices"  placeholder="如果带有语音请填 或者不用填。 单位 /分钟"></el-input>
                    </el-col>
                </el-form-item> 
                <el-form-item label="余额购买限制：" >
                    <el-col :span="22">
                        <el-input v-model="addOrEditPkgForm.userAmount"  placeholder="用户余额必须大于当前设置的金额(单位/元)才能购买此套餐"></el-input>
                    </el-col>
                </el-form-item> 
                
<!--                 
                <el-form-item label="允许修改价格：" prop="">
                    <el-radio-group v-model="addOrEditPkgForm.isUpdate">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
            </div>            
        </el-dialog>
    </div>
</template>
<script>
import {getPkgListPage, addPkg, updatePkg, getPkgDetail, changePkgState, adminPkgSort} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){
        var checkverifyPrice = (rule, value, callback) => {

            if(this.addOrEditPkgForm.salePriceRmb && Number(value) > Number(this.addOrEditPkgForm.salePriceRmb) ){
                return callback(new Error('套餐对账价必须小于等于套餐售价'))
            }
            this.$refs.addOrEditPkgForm.clearValidate(['origPriceRmb', 'salePriceRmb']);
            callback();
        }
        var checkOrigPrice = (rule, value, callback) => {
            if((value < this.addOrEditPkgForm.verifyPriceRmb && this.addOrEditPkgForm.verifyPriceRmb) || (value < this.addOrEditPkgForm.salePriceRmb && this.addOrEditPkgForm.salePriceRmb)){
                return callback(new Error('套餐分销价必须大于等于套餐对账价并且大于等于套餐售价'))
            }
            this.$refs.addOrEditPkgForm.clearValidate(['verifyPriceRmb', 'salePriceRmb']);
            callback();
        }  
        var checkSalekPrice = (rule, value, callback) => {
            if(this.addOrEditPkgForm.verifyPriceRmb && Number(value) < Number(this.addOrEditPkgForm.verifyPriceRmb) ){
                return callback(new Error('套餐售价必须大于等于套餐对账价'))
            }
            this.$refs.addOrEditPkgForm.clearValidate(['verifyPriceRmb','origPriceRmb']);
            callback();
        }
        var checkflowRate = (rule, value, callback) => {
            if(value * 100 > 9999){
                return callback(new Error('请输入1~99.99的数字'))
            }
            callback();
        }
          
        return {
            searchForm: {
                typeGroupId: '',
                type: '',
                supplierType: '',
                state: '',
                name: '',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            pkgTypeOption: [],
            pkgStateOption: [],
            supplierOption: [],
            addOrEditPkgForm: {
                typeGroupId: '',
                name: '',
                voices:'',
                verifyPriceRmb: '',
                userAmount:'',
                origPriceRmb: '',
                salePriceRmb: '',
                flowRate: '',
                type:'',
                flowRatePercent: '',
                isUpdate: 1,
                supplierType: 0,
                otherPkgId: '',
                remark:''                 
            },
            unit: 'G',
            currentId: '',
            addFlag: null,
            showVoice:false,
            addPkgVisibale: false,
            pkgGroup: [],
            myPkgGroup: [],
            title: '',
            addOrEditPkgRules: {
                typeGroupId: [
                    {required: true, message: '请选择套餐组名称', trigger: 'change'}
                ],
                type: [
                    {required: true, message: '请选择套餐类型', trigger: 'change'}
                ],
                name: [
                    {required: true, message: '请输入套餐名称', trigger: 'blur'}
                ],
                verifyPriceRmb: [
                    {required: true, message: '请输入套餐对账价格', trigger: 'blur'},
                    {validator: this.checkFloat, trigger: 'blur'},
                    {validator: checkverifyPrice, trigger: 'blur'}
                ],
                origPriceRmb: [
                    {required: true, message: '请输入套餐分销价', trigger: 'blur'},
                    {validator: this.checkFloat, trigger: 'blur'},
                    {validator: checkOrigPrice, trigger: 'blur'}
                ],
                salePriceRmb: [
                    {required: true, message: '请输入套餐售价', trigger: 'blur'},
                    {validator: this.checkFloat, trigger: 'blur'},
                    {validator: checkSalekPrice, trigger: 'blur'}
                ],
                flowRate: [
                    {required: true, message: '请输入流量', trigger: 'blur'}
                ],
                flowRatePercent: [
                    {required: true, message: '请输入可使用流量百分比', trigger: 'blur'},
                    {validator: checkflowRate, trigger: 'blur'}
                ],
            }
        }
    },
    methods: {
        cancel(){
            this.addPkgVisibale = false;    
            this.$refs.addOrEditPkgForm.resetFields();  
        },
        showbtnText(state){
            return common.showTxtByState(state, {0: '上架', 1: '下架'})
        },
        //同步上游套餐
        updateUpPkg(){
            common.sysRequest('pkg/update/up/pkg', null, 'get').then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        numberHandle(e){          
            var reg = /^\d+(\.\d{1,2})?/;
            if(reg.exec(e.target.value)) {
                e.target.value = reg.exec(e.target.value)[0];
            }                  
        },
        getPkgListPageHandle($event){   
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
  
            getPkgListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');               
            })
        },   
        showAddPkg(){
            this.addPkgVisibale = true;
            this.addFlag = true;
            this.title = '新增套餐';
            common.getPkgGroupListCom(this, 'pkgGroup');
        },
        showEditPkg(row){
            this.addPkgVisibale = true;
            this.addFlag = false;
            this.title = '修改套餐';  
            this.currentId = row.id;   
            var data = {
                id: row.id
            }
            getPkgDetail(data).then(res => {
                var result = res.data.data;
                for(var key in this.addOrEditPkgForm){
                    if(key == 'flowRate'){
                        if(result[key] < 1024){
                            this.addOrEditPkgForm[key] = result[key];
                            this.unit = 'M';
                        }else{
                            var MtoG = result[key] /1024;
                            this.addOrEditPkgForm[key] = Number.isInteger(MtoG) ? MtoG : MtoG.toFixed(2);                 
                            this.unit = 'G';
                        }
                    }else{
                        this.addOrEditPkgForm[key] = result[key]
                    }                    
                }
                common.getPkgGroupListCom(this, 'pkgGroup');
            })               
        },
        addOrEidtPkgHandle(){
            this.$refs.addOrEditPkgForm.validate(valid => {
                if(valid) {
                    this.addOrEditPkgForm.origPriceRmb = this.addOrEditPkgForm.salePriceRmb;
                    var data = JSON.parse(JSON.stringify(this.addOrEditPkgForm));
                    if(this.unit == 'G'){
                        data.flowRate = this.addOrEditPkgForm.flowRate*1024;
                    }
                    if(this.addFlag == true){
                        addPkg(data).then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);
                            }else{
                                this.$message.error(res.data.message);
                            }
                            callback(res);

                            for (let val in this.addOrEditPkgForm) {
                                this.addOrEditPkgForm[val] = "";
                            }

                        })
                    }else{
                        data.id = this.currentId
                        updatePkg(data).then(res => {
                            if(res.data.code == 200){
                                this.$message.success(res.data.message);
                            }else{
                                this.$message.error(res.data.message);
                            }
                            callback(res);
                        })               
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgListPageHandle();
                        _this.addPkgVisibale = false;
                        
                    }else{                        
                        _this.$message.error(res.data.message)
                    }                     
                }
            })             
        },
        changePkgStateHandle(id){
            var data = {
                id
            }
            changePkgState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getPkgListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        updateSortNo(row){
            //修改排序号
            var data = {
                id: row.id,
                sort: row.sort
            }
            adminPkgSort(data).then(res => {
                if(res.data.code == 200){
                    this.getPkgListPageHandle();
                }
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgListPageHandle();
        },
        //选择套餐组
        whenChoosePagGroup(val){
            for(let index in this.pkgGroup){
                if(this.pkgGroup[index].id == val){
                    this.addOrEditPkgForm.supplierType = this.pkgGroup[index].supplierType;
                    if( this.pkgGroup[index].isVoice==1){
                        this.showVoice=true;
                    }else{
                          this.showVoice=false;
                    }
                }
            }
            if(this.addOrEditPkgForm.supplierType == 66){
                common.sysRequest('external/pkg/list', null, 'get').then(res => {
                    if(res.data.code == 200){
                        this.myPkgGroup = res.data.data.map.pkgs;
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
            
        }

    },
    created () {
        this.getPkgListPageHandle();
        common.getPkgGroupListCom(this, 'pkgGroup');
        common.getPkgTypeOptionCom(this, 'pkgTypeOption');
        common.getSupplierOptionCom(this, 'supplierOption');
        common.getPkgStateOptionCom(this, 'pkgStateOption');
    }  
}
</script>
<style lang="less" >
.input-with-select .el-input {
    width: 60px;
}
</style>

